'use strict';

var d3 = require('d3');
var ChartFbcApplicability = function ChartFbcApplicability(chartFaresService, AbstractChart, scalesService, chartGroups, chartBelts, chartXAxis, chartYAxis, chartScales, chartFbcApplicabilityYAxisService, chartConstants) {
  var chartParams = require('./Params');
  var yNumberOfTicks = 6;
  var Chart = function Chart(container, formatters, chartModel) {
    //var self = this;

    AbstractChart.call(this, container);
    var dispatch = d3.dispatch('rangechange');
    d3.rebind(this, dispatch, 'on');

    // chart components
    var groups = chartGroups('startDate', undefined, true);
    var belts = chartBelts('startDate', 'endDate', 'fareValue', 'fares', formatters.tooltipFormatter);
    var xAxis = chartXAxis(formatters.xAxisTickFormatter);
    var yAxisLeft = chartYAxis(formatters.yAxisTickFormatter, chartConstants.AXIS.MODE.LEFT);
    yAxisLeft.label('Fares').withoutHorizontalLines();
    this.render = function () {
      var xAxisValues = chartModel.getXAxisValues;
      var range = [0, xAxisValues.length];
      this.initChart(chartModel.data.grouped, range, chartParams);
      this.scales = chartScales(this.params, chartModel.data.grouped, xAxisValues, range);
      var yAxisConfig = chartFbcApplicabilityYAxisService.getYAxisTicksConfig(this.scales.yScale, yNumberOfTicks);
      this.params.yNumberOfTicks = yAxisConfig.yNumberOfTicks;
      yAxisLeft.withTickValues(yAxisConfig.tickValues);
      this.callForDataGroup([yAxisLeft, groups, belts, xAxis], this.scales);
    };
  };
  Chart.prototype = Object.create(AbstractChart.prototype);
  Chart.constructor = Chart;
  return Chart;
};
ChartFbcApplicability.$inject = ['ChartFaresService', 'AbstractChart', 'ScalesService', 'ChartElementsGroup', 'ChartElementsBelts', 'ChartElementsXAxis', 'ChartElementsYAxis', 'ChartFBCApplicabilityScalesFactory', 'ChartFbcApplicabilityYAxisService', 'ChartElementsConstants'];
module.exports = ChartFbcApplicability;